import { User } from 'firebase/auth';
import { UserProfile, UserRole } from '@/shared/types';

/**
 * Convert Firebase User to UserProfile format
 * Moved to shared layer as multiple features need profile conversion
 */
export function firebaseUserToProfile(user: User, additionalData?: Partial<UserProfile>): UserProfile {
  const profile: UserProfile = {
    id: user.uid,
    userId: user.uid, // Alias for id for compatibility with service layer
    name: user.displayName || user.email?.split('@')[0] || 'Unknown',
    email: user.email || '',
    role: UserRole.FREELANCER, // Default role
    businessEmail: additionalData?.businessEmail || user.email || '',
    brandColor: additionalData?.brandColor || '#4f46e5',
    template: additionalData?.template || 'modern',
    subscription: additionalData?.subscription || {
      planId: 'free',
      status: 'active',
      nextBillingDate: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString(),
      billingPeriod: 'monthly'
    },
    country: additionalData?.country || 'US',
    currency: additionalData?.currency || 'USD',
    savedServices: additionalData?.savedServices || [],
    paymentMethods: additionalData?.paymentMethods || [],
    joinedAt: additionalData?.joinedAt || user.metadata.creationTime || new Date().toISOString(),
    notificationPreferences: additionalData?.notificationPreferences || {
      email: { jobUpdates: true, paymentReminders: true, clientOnboarding: true },
      whatsapp: { jobUpdates: false, paymentReminders: true, clientOnboarding: false },
      push: { jobUpdates: true, paymentReminders: true, clientOnboarding: true },
      sms: { jobUpdates: false, paymentReminders: false, clientOnboarding: false }
    }
  };

  // Only set optional properties if they have values
  if (additionalData?.businessName) profile.businessName = additionalData.businessName;
  if (additionalData?.businessAddress) profile.businessAddress = additionalData.businessAddress;
  if (additionalData?.businessPhone) profile.businessPhone = additionalData.businessPhone;
  if (additionalData?.logoUrl) profile.logoUrl = additionalData.logoUrl;
  if (additionalData?.avatarUrl) profile.avatarUrl = additionalData.avatarUrl;
  else if (user.photoURL) profile.avatarUrl = user.photoURL;
  if (additionalData?.phone) profile.phone = additionalData.phone;
  if (additionalData?.hasCompletedOnboarding !== undefined) profile.hasCompletedOnboarding = additionalData.hasCompletedOnboarding;

  return profile;
}
